export default __webpack_public_path__ + "static/media/Chat-Numbers-System-12.dd41a1df.svg";